var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]}),_vm._v(" "),_c('booking-statistic',{attrs:{"is-prev":"true","zoneId":_vm.zone,"floorId":"","filter":"months","from":_vm.from,"to":_vm.to,"show-input":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }